/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ITypeOrIdOrTitleOrDescriptionOrBadgeImageOrLargeBadgeImageOrRelatedIdOrMilestoneCountOrMilestoneYearOrPreCompletionTextOrPostCompletionTextOrRedemptionLinkOrHasTiersOrUpdatedAtOrCreatedAt {
  Type = 'type',
  Id = 'id',
  Title = 'title',
  Description = 'description',
  BadgeImage = 'badgeImage',
  LargeBadgeImage = 'largeBadgeImage',
  RelatedId = 'relatedId',
  MilestoneCount = 'milestoneCount',
  MilestoneYear = 'milestoneYear',
  PreCompletionText = 'preCompletionText',
  PostCompletionText = 'postCompletionText',
  RedemptionLink = 'redemptionLink',
  HasTiers = 'hasTiers',
  UpdatedAt = 'updatedAt',
  CreatedAt = 'createdAt',
}
